import requests from '@/utils/requests';

/**
 * 评审列表接口
 * @param {*} data
 */
export function reviewList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/list',
    method: 'post',
    data
  });
}

/**
 * 添加评审接口
 * @param {*} data
 */
export function reviewAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/add',
    method: 'post',
    data
  });
}

/**
 * 删除评审接口
 * @param {*} data
 */
export function reviewDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/delete',
    method: 'post',
    data
  });
}

/**
 * 复制评审接口
 * @param {*} data
 */
export function reviewCopy(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/copy',
    method: 'post',
    data
  });
}

/**
 * 评审锁定
 * @param {*} data
 */
export function reviewLock(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/lockCases',
    method: 'post',
    data
  });
}

/**
 * 评审单更新接口
 * @param {*} data
 */
export function reviewUpdate(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/update',
    method: 'post',
    data
  });
}

/**
 * 评审单更新某字段接口
 * @param {*} data
 */
export function reviewUpdateItem(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/update/item',
    method: 'post',
    data
  });
}

/**
 * 评审单状态更新接口
 * @param {*} data
 */
export function reviewUpdateStatus(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/update/status',
    method: 'post',
    data
  });
}

/**
 * 评审详情接口
 * @param {*} data
 */
export function reviewDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/detail',
    method: 'post',
    data
  });
}

/**
 * 获取评审单关联测试用例ID接口
 * @param {*} data
 */
export function reviewBindCaseIds(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/caseIds',
    method: 'post',
    data
  });
}

/**
 * 获取评审单关联测试用例ID接口
 * @param {*} data
 */
export function reviewBindStoryIds(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/storyIds',
    method: 'post',
    data
  });
}

/**
 * 评审单关联测试用例接口
 * @param {*} data
 */
export function bindTestCases(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/bindCases',
    method: 'post',
    data
  });
}

/**
 * 评审单关联对象接口
 * @param {*} data
 */
export function reviewBindObject(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/bindObject',
    method: 'post',
    data
  });
}

/**
 * 评审单关联测试用例接口
 * @param {*} data
 */
export function bindStories(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/bindStories',
    method: 'post',
    data
  });
}

/**
 * 评审单获取变更记录接口
 * @param {*} data
 */
export function reviewRecord(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/record',
    method: 'post',
    data
  });
}

/**
 * 获取测试计划关联测试用例详情接口
 * @param {*} data
 */
export function reviewRelatedCases(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/relatedCases',
    method: 'post',
    data
  });
}

/**
 * 获取测试计划关联测试用例详情接口
 * @param {*} data
 */
export function reviewRelatedStories(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/relatedStories',
    method: 'post',
    data
  });
}

/**
 * 获取测试计划关联任务列表接口
 * @param {*} data
 */
export function reviewRelatedTask(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/relatedTask',
    method: 'post',
    data
  });
}

/**
 * 用例详情接口
 * @param {*} data
 */
export function reviewCaseDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/caseDetail',
    method: 'post',
    data
  });
}

/**
 * 需求详情接口
 * @param {*} data
 */
export function reviewStoryDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/storyDetail',
    method: 'post',
    data
  });
}

/**
 * 需求详情接口
 * @param {*} data
 */
export function reviewTaskDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/taskDetail',
    method: 'post',
    data
  });
}

/**
 * 更新测试结果接口
 * @param {*} data
 */
export function updateReviewItemResult(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/itemResult',
    method: 'post',
    data
  });
}

/**
 * 评审单签字接口
 * @param {*} data
 */
export function reviewSign(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/sign',
    method: 'post',
    data
  });
}

/**
 * 根据需求ID获取需求标题和Key
 * @param {*} data
 */
export function reviewStoryList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/storyList',
    method: 'post',
    data
  });
}
